export const ROLES = {
    DOSSIER_MANAGEMENT: "Dossier Management",
    BEGINNER_MEDICAL_ASSISTANT: "Hulpverlener",
    INTERMEDIATE_MEDICAL_ASSISTANT: "Allround hulpverlener",
    ADVANCED_MEDICAL_ASSISTANT: "Kern hulpverlener",
    MEDICAL_ASSISTANT_TRAFFIC_CONTROLLER: "Medical Assistance Traffic Controller",
    DOCTORS_NURSES: "Nurse",
    TRAVEL_ASSISTANT: "Travel Agent",
    KWALITEIT_EN_SUPPORT_PERSONNEL: "Implementatie Manager",
    COST_CONTROL: "Cost Control",
    INKOOP_EN_NETWEK_PERSONNEL: "Netwerk en Inkoop",
    MID_OFFICE_FINANCE: "Mid office finance",
    ADMINISTRATORS: "Administrator",
    DBC_MANAGEMENT: "DBC Management",
    PRODUCT_OWNER: "Product Owner",
    SENIOR_HULPVERLENER: "Senior hulpverlener",
    SOS_TEAM_MANAGER: "SOS Team Manager",
};
  